import { Gallery } from "../MediaGallery";
import ProductForm from "./ProductForm";
import { getMediaListFromProduct } from "../lib/get-media";
import styles from "./styles/view.module.css";

export function ProductItem({
  currentProduct,
  productGroup,
  settings,
  setCurrentProduct,
  openReviewsDrawer,
}) {
  const previewOnHover = (previewProduct) => {
    let preview = null;

    if (previewProduct) {
      preview = productGroup.shopifyProducts.find(
        ({ productReferenceV2 }) => productReferenceV2.id === previewProduct
      );
    }
    if (preview) {
      setCurrentProduct(preview);
    }
  };

  const mediaList = getMediaListFromProduct(productGroup, currentProduct);

  return (
    <div className={styles.container}>
      {currentProduct && currentProduct.productReferenceV2 && (
        <>
          <Gallery title={productGroup.title} media={mediaList} />
          <ProductForm
            productGroup={productGroup}
            initProduct={currentProduct.productReferenceV2}
            settings={settings}
            previewOnHover={previewOnHover}
            openReviewsDrawer={openReviewsDrawer}
          />
        </>
      )}
    </div>
  );
}
